import * as React from 'react';
import './styles/Badge.scss';

type Props = {
  label: string;
  icon?: string;
};

const Badge: React.FC<Props> = (props) => {
  return (
    <div className="badge">
      {props.icon && <i className="material-symbols">{props.icon}</i>}
      <span className="badge-label">{props.label}</span>
    </div>
  );
};

export default Badge;
